<template>
    <div class="statistics">
        <div class="bgc coupon_msg">
            <div class="coupon_name_get">
                <div class="left">
                    {{couponMsg.name}}（领取数量：{{couponMsg.currentgetcount}}）
                </div>
                <div class="right" @click="returnList">返回优惠券列表</div>
            </div>
            <div class="coupon_data">
                <div class="item">
                    <div class="title">
                        用券成交额（元）
                        <el-tooltip class="item" effect="dark" content="使用该优惠券的订单付款总金额" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.totalordermoney}}</div>
                </div>
                <div class="item">
                    <div class="title">
                        优惠总金额
                        <el-tooltip class="item" effect="dark" content="使用该优惠券所优惠的总金额" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.totaldismoney}}</div>
                </div>
                <div class="item">
                    <div class="title">
                        费效比
                        <el-tooltip class="item" effect="dark" content="优惠总金额/用券总成交额" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.roivalue}}%</div>
                </div>
                <div class="item">
                    <div class="title">
                        客单价（元）
                        <el-tooltip class="item" effect="dark" content="用券总成交额/使用该优惠券的付款订单数" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.userprice}}</div>
                </div>
                <div class="item">
                    <div class="title">
                        领劵用户数
                        <el-tooltip class="item" effect="dark" content="优惠券到账的用户数" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.vouchercustomercount}}</div>
                </div>
                <div class="item">
                    <div class="title">
                        用券用户数
                        <el-tooltip class="item" effect="dark" content="使用该优惠券的成交用户数" placement="top">
                            <i class="el-icon-warning"></i>
                        </el-tooltip>
                    </div>
                    <div class="value">{{couponMsg.usecustomercount}}</div>
                </div>
            </div>
        </div>
        <div class="padding-20 bgc box-shadow listBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="领/用券用户" name="userList">
                    <userList ref="userList" />
                </el-tab-pane>
                <el-tab-pane label="用券商品" name="goodsList">
                    <goodsList ref="goodsList" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import {getCoupnvoucherInfoStatistics, getCoupnvoucherInfoByCustomer, getCoupnvoucherInfoByCustomasset} from 'api/marketingCenterApi'
import {mapActions, mapGetters} from 'vuex'
import userList from './statistics/components/userList'
import goodsList from './statistics/components/goodsList'
export default {
    name: 'statistics',
    data() {
        return {
            params: {
                couponvoucherid: this.$route.query.couponvoucherid
            },
            couponMsg: {},
            activeName: 'userList'
        }
    },
    created() {
        this.getCoupnvoucherInfoStatistics()
    },
    methods: {
        getCoupnvoucherInfoStatistics() {
            this.setLoading(true)
            getCoupnvoucherInfoStatistics({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    this.couponMsg = res.data
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        getCoupnvoucherInfoByCustomer() {
            getCoupnvoucherInfoByCustomer({

            })
        },
        handleClick() {

        },
        returnList() {
            this.$router.back(1)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        userList,
        goodsList
    }
}
</script>
<style lang="scss">
    .statistics {
        .coupon_msg {
            padding: 20px 20px 46px;
            margin-bottom: 20px;
            .coupon_name_get {
                padding: 20px;
                background: #FAFAFA;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left {
                    font-weight: bold;
                }
                .right {
                    color: #409EFF;
                    cursor: pointer;
                    font-size: 14px;
                }
            }
            .coupon_data {
                padding: 30px 20px;
                background: #FAFAFA;
                display: flex;
                .item {
                    flex: 1;
                    &:not(:last-of-type) {
                        border-right: 1px solid #DCDFE6;
                        margin-right: 20px;
                    }
                    .title {
                        font-size: 16px;
                        position: relative;
                        top: -10px;
                        .el-icon-warning {
                            color: #999999;
                        }
                    }
                    .value {
                        font-size: 28px;
                        line-height: 32px;
                        position: relative;
                        top: 8px;
                        // font-weight: bold;
                    }
                }
            }
        }
        .listBox {
            // background: ;
        }
    }
</style>